import { Alert, AlertTitle } from "@mui/material";
import React from "react";
import { toast as t } from "react-hot-toast";
export const useToast = () => {
  const toast = ({ variant = "info", title, description }) => {
    t(
      (t) => (
        <Alert severity={variant}>
          <AlertTitle>{title}</AlertTitle>
          {description}
        </Alert>
      ),
      {
        style: {
          background: "transparent",
          boxShadow: "none",
        },
      }
    );
  };
  return { toast };
};
